import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@/lib/queryKeys'
import * as alerts from '@/lib/api/alerts'
import type { AlertParams } from '@/lib/api/alerts'

export function useAlertList(params: AlertParams) {
  return useQuery({
    queryKey: queryKeys.alerts.list({ ...params }),
    queryFn: () => alerts.list(params),
  })
}

// Open-alert counts behind the nav badge and the global banner. Refreshed every
// minute, paused while the tab is hidden (refetchIntervalInBackground defaults
// to false) — same cadence as the Opportunities view.
export function useAlertSummary() {
  return useQuery({
    queryKey: queryKeys.alerts.summary,
    queryFn: alerts.summary,
    refetchInterval: 60_000,
  })
}

export function useResolveAlert() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => alerts.resolve(id),
    // `alerts.all` prefixes both every list and the summary.
    onSuccess: () => void qc.invalidateQueries({ queryKey: queryKeys.alerts.all }),
  })
}
